import { render } from "./SelectSearch.vue?vue&type=template&id=522b4f6d&scoped=true"
import script from "./SelectSearch.vue?vue&type=script&lang=js"
export * from "./SelectSearch.vue?vue&type=script&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=522b4f6d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-522b4f6d"

export default script